/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { IncidentDto } from '../models/incident-dto';
import { IncidentPhotoDto } from '../models/incident-photo-dto';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des incidents
 */
@Injectable({
  providedIn: 'root',
})
export class IncidentsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation incidentGetList
   */
  static readonly IncidentGetListPath = '/api/incidents/list';

  /**
   * Renvoie la liste des incidents.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `incidentGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  incidentGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<IncidentDto>>> {

    const rb = new RequestBuilder(this.rootUrl, IncidentsService.IncidentGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<IncidentDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des incidents.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `incidentGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  incidentGetList(params?: {
  }): Observable<Array<IncidentDto>> {

    return this.incidentGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<IncidentDto>>) => r.body as Array<IncidentDto>)
    );
  }

  /**
   * Path part for operation incidentLoadList
   */
  static readonly IncidentLoadListPath = '/api/incidents/load-list';

  /**
   * Renvoie la liste des incidents (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `incidentLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  incidentLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, IncidentsService.IncidentLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des incidents (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `incidentLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  incidentLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.incidentLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation incidentGet
   */
  static readonly IncidentGetPath = '/api/incidents/{id}';

  /**
   * Renvoie l'incident spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `incidentGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  incidentGet$Response(params: {

    /**
     * Identifiant de l&#x27;incident
     */
    id: number;
  }): Observable<StrictHttpResponse<IncidentDto>> {

    const rb = new RequestBuilder(this.rootUrl, IncidentsService.IncidentGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IncidentDto>;
      })
    );
  }

  /**
   * Renvoie l'incident spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `incidentGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  incidentGet(params: {

    /**
     * Identifiant de l&#x27;incident
     */
    id: number;
  }): Observable<IncidentDto> {

    return this.incidentGet$Response(params).pipe(
      map((r: StrictHttpResponse<IncidentDto>) => r.body as IncidentDto)
    );
  }

  /**
   * Path part for operation incidentPut
   */
  static readonly IncidentPutPath = '/api/incidents/{id}';

  /**
   * Met à jour l'incident spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `incidentPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  incidentPut$Response(params: {

    /**
     * Identifiant de l&#x27;incident à mettre à jour
     */
    id: number;

    /**
     * Incident
     */
    body: IncidentDto
  }): Observable<StrictHttpResponse<IncidentDto>> {

    const rb = new RequestBuilder(this.rootUrl, IncidentsService.IncidentPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IncidentDto>;
      })
    );
  }

  /**
   * Met à jour l'incident spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `incidentPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  incidentPut(params: {

    /**
     * Identifiant de l&#x27;incident à mettre à jour
     */
    id: number;

    /**
     * Incident
     */
    body: IncidentDto
  }): Observable<IncidentDto> {

    return this.incidentPut$Response(params).pipe(
      map((r: StrictHttpResponse<IncidentDto>) => r.body as IncidentDto)
    );
  }

  /**
   * Path part for operation incidentDelete
   */
  static readonly IncidentDeletePath = '/api/incidents/{id}';

  /**
   * Supprime l'incident spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `incidentDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  incidentDelete$Response(params: {

    /**
     * Identifiant de l&#x27;incident à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, IncidentsService.IncidentDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime l'incident spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `incidentDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  incidentDelete(params: {

    /**
     * Identifiant de l&#x27;incident à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.incidentDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation incidentPost
   */
  static readonly IncidentPostPath = '/api/incidents';

  /**
   * Crée l'incident spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `incidentPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  incidentPost$Response(params: {

    /**
     * Incident
     */
    body: IncidentDto
  }): Observable<StrictHttpResponse<IncidentDto>> {

    const rb = new RequestBuilder(this.rootUrl, IncidentsService.IncidentPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IncidentDto>;
      })
    );
  }

  /**
   * Crée l'incident spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `incidentPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  incidentPost(params: {

    /**
     * Incident
     */
    body: IncidentDto
  }): Observable<IncidentDto> {

    return this.incidentPost$Response(params).pipe(
      map((r: StrictHttpResponse<IncidentDto>) => r.body as IncidentDto)
    );
  }

  /**
   * Path part for operation incidentPostMultiple
   */
  static readonly IncidentPostMultiplePath = '/api/incidents/multiple';

  /**
   * Crée plusieurs incidents pour une visite.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `incidentPostMultiple()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  incidentPostMultiple$Response(params: {

    /**
     * Incidents
     */
    body: Array<IncidentDto>
  }): Observable<StrictHttpResponse<Array<IncidentDto>>> {

    const rb = new RequestBuilder(this.rootUrl, IncidentsService.IncidentPostMultiplePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<IncidentDto>>;
      })
    );
  }

  /**
   * Crée plusieurs incidents pour une visite.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `incidentPostMultiple$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  incidentPostMultiple(params: {

    /**
     * Incidents
     */
    body: Array<IncidentDto>
  }): Observable<Array<IncidentDto>> {

    return this.incidentPostMultiple$Response(params).pipe(
      map((r: StrictHttpResponse<Array<IncidentDto>>) => r.body as Array<IncidentDto>)
    );
  }

  /**
   * Path part for operation incidentGetPhotos
   */
  static readonly IncidentGetPhotosPath = '/api/incidents/{id}/photos';

  /**
   * Récupère la liste des photos liées à l'incident spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `incidentGetPhotos()` instead.
   *
   * This method doesn't expect any request body.
   */
  incidentGetPhotos$Response(params: {

    /**
     * Identifiant de l&#x27;incident
     */
    id: number;
  }): Observable<StrictHttpResponse<Array<IncidentPhotoDto>>> {

    const rb = new RequestBuilder(this.rootUrl, IncidentsService.IncidentGetPhotosPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<IncidentPhotoDto>>;
      })
    );
  }

  /**
   * Récupère la liste des photos liées à l'incident spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `incidentGetPhotos$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  incidentGetPhotos(params: {

    /**
     * Identifiant de l&#x27;incident
     */
    id: number;
  }): Observable<Array<IncidentPhotoDto>> {

    return this.incidentGetPhotos$Response(params).pipe(
      map((r: StrictHttpResponse<Array<IncidentPhotoDto>>) => r.body as Array<IncidentPhotoDto>)
    );
  }

  /**
   * Path part for operation incidentGetIncidentPhoto
   */
  static readonly IncidentGetIncidentPhotoPath = '/api/incidents/photos/{incidentPhotoId}';

  /**
   * Télécharge la photo d'un incident spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `incidentGetIncidentPhoto()` instead.
   *
   * This method doesn't expect any request body.
   */
  incidentGetIncidentPhoto$Response(params: {

    /**
     * Identifiant de la photo d&#x27;un incident
     */
    incidentPhotoId: number;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, IncidentsService.IncidentGetIncidentPhotoPath, 'get');
    if (params) {
      rb.path('incidentPhotoId', params.incidentPhotoId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Télécharge la photo d'un incident spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `incidentGetIncidentPhoto$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  incidentGetIncidentPhoto(params: {

    /**
     * Identifiant de la photo d&#x27;un incident
     */
    incidentPhotoId: number;
  }): Observable<void> {

    return this.incidentGetIncidentPhoto$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation incidentAddIncidentPhoto
   */
  static readonly IncidentAddIncidentPhotoPath = '/api/incidents/{id}/photo';

  /**
   * Ajoute une photo à l'incident spécifié
   * Taille maximum pour la photo : 20Mb.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `incidentAddIncidentPhoto()` instead.
   *
   * This method doesn't expect any request body.
   */
  incidentAddIncidentPhoto$Response(params: {

    /**
     * Identifiant de l&#x27;incident
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, IncidentsService.IncidentAddIncidentPhotoPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Ajoute une photo à l'incident spécifié
   * Taille maximum pour la photo : 20Mb.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `incidentAddIncidentPhoto$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  incidentAddIncidentPhoto(params: {

    /**
     * Identifiant de l&#x27;incident
     */
    id: number;
  }): Observable<number> {

    return this.incidentAddIncidentPhoto$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation incidentAddIncidentPhotoPda
   */
  static readonly IncidentAddIncidentPhotoPdaPath = '/api/incidents/{id}/photo-incident/pda';

  /**
   * Ajoute une ou plusieurs photo PDA à l'incident spécifié (intervention).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `incidentAddIncidentPhotoPda()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  incidentAddIncidentPhotoPda$Response(params: {

    /**
     * Identifiant de l&#x27;incident
     */
    id: number;

    /**
     * Identifiants des photosPda
     */
    body: Array<number>
  }): Observable<StrictHttpResponse<IncidentDto>> {

    const rb = new RequestBuilder(this.rootUrl, IncidentsService.IncidentAddIncidentPhotoPdaPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IncidentDto>;
      })
    );
  }

  /**
   * Ajoute une ou plusieurs photo PDA à l'incident spécifié (intervention).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `incidentAddIncidentPhotoPda$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  incidentAddIncidentPhotoPda(params: {

    /**
     * Identifiant de l&#x27;incident
     */
    id: number;

    /**
     * Identifiants des photosPda
     */
    body: Array<number>
  }): Observable<IncidentDto> {

    return this.incidentAddIncidentPhotoPda$Response(params).pipe(
      map((r: StrictHttpResponse<IncidentDto>) => r.body as IncidentDto)
    );
  }

}
